/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * limit: 每页显示条数
 *
 */
 // const BASE_URL = 'http://localhost:8083';
const BASE_URL = 'https://member-api.im502.com';
// const BASE_URL = 'https://order-api.yakult-gz.com.cn';

const ROUTER_MODE = 'hash';
// const ROUTER_MODE = 'history';

const LIMIT = 10;

//微信授权APPID
// const WX_CODE = 'wx29e8864a1e6591fd';
//正式
const WX_CODE = 'wxc80a1080eb737c60';

const PASSWORD_MOBILE = '800 8308960';

//游戏链接地址
//二月替换游戏链接-2月是最后一个月
const GAME_URL = "https://23673962-335.fkhdview.com/23673962/cJDOx1qtge8_oq0iPrfCHg/load-23673962-335.html?style=85&editQrcode=true&_source=1";
// const GAME_URL = "https://23673962-325.fkhdview.com/23673962/cJDOx1qtge_PU715QvXnCw/load-23673962-325.html?style=85&editQrcode=true&_source=1";
// const GAME_URL = "https://23673962-316.fkhdview.com/23673962/cJDOx1qtge9cXYRt6Jsqdw/load-23673962-316.html?style=85&_source=1";
// const GAME_URL = "https://23673962-288.fkhdview.com/23673962/cJDOx1qtge--hM1-gpsNcg/load-23673962-288.html?style=85&_source=1";
// const GAME_URL = "https://23673962-278.fkhdview.com/23673962/cJDOx1qtge_BPLH7pAIgoA/load-23673962-278.html?style=85&_source=1";
// const GAME_URL = "https://23673962-267.fkhdview.com/23673962/cJDOx1qtge-0lGienwCJ9Q/load-23673962-267.html?style=85&editQrcode=true&_source=1";
// const GAME_URL = "https://23673962-263.fkhdview.com/23673962/cJDOx1qtge-prG3O6pvniw/load-23673962-263.html?style=85&editQrcode=true&_source=1";
// const GAME_URL = "https://23673962-253.fkhdview.com/23673962/cJDOx1qtge-N0Zdz2R8jhw/load-23673962-253.html?style=85&editQrcode=true&_source=1";
// const GAME_URL = 'https://23673962-244.fkhdview.com/23673962/cJDOx1qtge-qbA1oX9W79w/load-23673962-244.html?style=85&editQrcode=true&_source=1';
// const GAME_URL = 'https://23673962-220.fkhdview.com/23673962/cJDOx1qtge_DId-ItNGwFQ/load-23673962-220.html?style=85&editQrcode=true&_source=1';
//
export { BASE_URL, ROUTER_MODE, LIMIT, WX_CODE, PASSWORD_MOBILE, GAME_URL};
